import { ReactNode } from 'react';
import { useFormState } from 'react-final-form';
import Button from 'components/Button';
import { InvoiceBuilderTemplate } from '../types';
import { Footer } from './styled';

export type DrawerMode = 'form' | 'preview';

interface FormFooterProps {
    formId?: string;
    mode?: DrawerMode;
    submitButtonLabel?: ReactNode;
    submitDisabled?: boolean;
    onPreviewClick?: () => void;
    onClosePreviewClick?: () => void;
    onCancelClick?: () => void;
}

const FormFooter = ({
    formId,
    mode = 'form',
    submitButtonLabel = 'Create',
    submitDisabled = false,
    onPreviewClick = () => {},
    onClosePreviewClick = () => {},
    onCancelClick = () => {},
}: FormFooterProps) => {
    const { values } = useFormState();
    const hasTemplate = Boolean(values.template as InvoiceBuilderTemplate | undefined);

    if (mode === 'preview') {
        return (
            <Footer>
                <Button
                    type="button"
                    label="Close preview"
                    variant="outline-brand"
                    borderRadius="semi-square"
                    onClick={onClosePreviewClick}
                />
            </Footer>
        );
    }

    return (
        <Footer>
            <Button
                type="button"
                label="Close"
                variant="outline-brand"
                borderRadius="semi-square"
                className="rainbow-m-right_medium"
                onClick={onCancelClick}
            />
            <Button
                type="button"
                label="Preview"
                variant="neutral"
                borderRadius="semi-square"
                className="rainbow-m-right_medium"
                disabled={!hasTemplate}
                onClick={onPreviewClick}
            />
            <Button
                label={submitButtonLabel}
                variant="brand"
                form={formId}
                type="submit"
                borderRadius="semi-square"
                disabled={submitDisabled}
            />
        </Footer>
    );
};

export default FormFooter;
